import { render } from "./AccessRights.vue?vue&type=template&id=cab5e91e&scoped=true&ts=true&lang=pug"
import script from "./AccessRights.vue?vue&type=script&lang=ts"
export * from "./AccessRights.vue?vue&type=script&lang=ts"

import "./AccessRights.vue?vue&type=style&index=0&id=cab5e91e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cab5e91e"]])

export default __exports__